
import React from 'react';
import { Info } from "lucide-react";

export default function CreditInfoBanner() {
  return (
    <div className="bg-stewie-blue/10 border border-stewie-blue/30 rounded-md p-4 text-sm flex gap-3">
      <Info size={20} className="text-stewie-blue mt-0.5 flex-shrink-0" />
      
      <div className="text-stewie-gray">
        <p className="font-medium text-white mb-1">About Stewie Credits</p>
        <p>
          Stewie Credits are used to execute trading strategies on the platform. Each credit represents $1,000 of tradeable Assets Under Management (AUM). 
          Credits are consumed when you execute trading strategies proportional to the AUM utilized.
        </p>
      </div>
    </div>
  );
}
